if(["/pages/registration-form-with-eu-vat-validation", "/account/register"].includes(window.location.pathname)) {
  const allowCountries = ["AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE"];
  
  window.addEventListener("load", function() {
    const registerForm = document.querySelector("#RegisterForm, #create_customer");
    const countryFieldList = registerForm.querySelector(".field-country-field #country-field-list");
    
    if(countryFieldList) {
      const countryItems = countryFieldList.querySelectorAll("li");
      
      countryItems.forEach(function (item) {
        const itemValue = item.getAttribute("value");
        if(!allowCountries.includes(itemValue)) {
          item.classList.add("country--hide");
        };
      })
    }
  })
}

if(["/account/register"].includes(window.location.pathname)) {
  window.addEventListener("load", function () {
    const registerForm = document.querySelector("#RegisterForm, #create_customer");
    const emailFieldWrapper = registerForm.querySelector(".form__input-wrapper:has(input[id='customer[email]'])");
    const bssFormBottom = registerForm.querySelector("#bss-b2b-registration-form-render");

    emailFieldWrapper.after(bssFormBottom);
  })
}

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const registerForm = document.querySelector("#bss-b2b-registration-form");

    if (registerForm) {
      const submitButton = registerForm.querySelector(".bss-b2b-rf-submit-button input[type='submit']");
      submitButton.value = "CREATE MY ACCOUNT";
    }
  }, 1000);
})

if(typeof BSS_B2B != undefined) {
  window.addEventListener("cart_changed", () => {
    setTimeout(() => {
      let storeData = JSON.parse($("#bss-b2b-store-data").html());
      // BSS_B2B.makeChangesAfterClickAjaxCart(500)
      BSS_B2B.cart.fixer(storeData, null, false);
      BSS_B2B.handleCartCheckoutBtn(storeData);
    }, 500);
  });

  setTimeout(() =>{
    const targetMiniCart = document.querySelector("#mini-cart");
    if (targetMiniCart) {
      const mutationObserver = new MutationObserver((recordList, observe) => {
          // BSS_B2B.makeChangesAfterClickAjaxCart(500)
           BSS_B2B.cart.fixer(JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML),false,false);
          setTimeout(() =>{
            BSS_B2B.handleCartCheckoutBtn(JSON.parse($("#bss-b2b-store-data").html()));
          }, 1000)
      });
      mutationObserver.observe(targetMiniCart, { attributes: true });
    }
  }, 500)

//fix spam checkout 
  setTimeout(() =>{
    function handleButtonClick(e) {
        e.preventDefault();
        const $button = $(this);
        let oldText = $(this).text();
        $button.css({'pointer-events': 'none', 'opacity': '0.6'});
        $button.text("Loading ...");
        setTimeout(() =>{
          $button.css({'pointer-events': 'unset', 'opacity': '1'})
            $button.text(oldText);
        }, 2000);
    }
   
   $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
  }, 500)

BSS_B2B.customTriggerCheckoutBtn = function(checkoutBtn){
    window.location.href = "/checkout";
  }
  
}